import React from "react";
import classnames from "classnames";
import { asField } from "informed";
import { FaMinus, FaPlus } from "react-icons/fa";

// import { Form, useField } from "informed";

export const NumberInput = asField(({ fieldState, fieldApi, ...props }) => {
  const { value = 0 } = fieldState;
  const { setValue, setTouched } = fieldApi;
  const {
    onChange,
    onBlur,
    min = 0,
    max = 10,
    faClass,
    icon,
    forwardedRef,
    label,
    className,
    field,
    ...rest
  } = props;
  const incrementValue = () => {
    if (value < max) {
      setValue(value + 1);
      if (onChange) {
        onChange(value,"increment");
      }
    } else {
      window.alert("Maximum Value Exceeded");
    }
  };
  const decrementValue = () => {
    if (value > min) {
      setValue(value - 1);
      if (onChange) {
        onChange(value,"decrement");
      }
    } else {
      window.alert("Minimum Value Exceeded");
    }
  };
  return (
    <React.Fragment>
      <div className="form-group">
        {faClass && !icon && <i className={faClass}></i>}
        {label && (
          <label htmlFor={field}>
            {icon && icon}
            {label}
            {props.required && <i style={{ color: "red" }}>*</i>}
          </label>
        )}
        <div className="number-input">
          <span onClick={decrementValue} className="minus-btn">
            <FaMinus fontSize={"13px"} />
          </span>
          <input
            {...rest}
            ref={forwardedRef}
            value={!value && value !== 0 ? "" : value}
            onChange={(e) => {
              setValue(e.target.value);
              if (onChange) {
                onChange(e);
              }
            }}
            onBlur={(e) => {
              setTouched(true);
              if (onBlur) {
                onBlur(e);
              }
            }}
            className={classnames(`form-control ${className}`)}
          />
          <span onClick={incrementValue} className="plus-btn">
            <FaPlus fontSize={"13px"} />
          </span>
        </div>
        {fieldState.error ? (
          <small style={{ color: "red" }}>{fieldState.error}</small>
        ) : null}
      </div>
    </React.Fragment>
  );
});
